import _ from 'lodash';

import {
  ADD_NEW_DISTRIBUTION_LIST_ROW,
  ADD_NEW_DISTRIBUTION_LIST_ROWS,
  ADD_VALIDATION_ERRORS,
  CLEAR_REPORT_DESIGNER_STORE,
  DELETE_CONTROLS,
  DELETE_DISTRIBUTION_LIST_ROW,
  DELETE_VALIDATION_ERRORS,
  SET_IS_REPORT_SUBMITTED,
  SET_ORIGINAL_REPORT_MODEL,
  SET_REPORT_DATA,
  SET_SELECTED_CONTROL_OBJECT,
  SET_SELECTED_TAB_INDEX,
  UPDATE_CONTROL,
  UPDATE_CONTROL_PROPERTIES,
  UPDATE_CONTROL_PROPERTY,
} from '../actions/report-designer.actions';
import { REPORT_CONTROL_TYPE, REPORT_LAYOUT_ID } from '../constants/report-designer.constants';

const initialState = {
  reportModel: {},
  originalReportModel: {},
  reportInfo: {},
  selectedControlObject: { id: REPORT_LAYOUT_ID, hasControlWrapper: false },
  selectedTabIndex: 0,
  reportModelEntityHierarchy: [],
  reportModelEntityDefinition: {},
  isReportSubmitted: false,
  validationErrors: [],
  entityFieldsTranslation: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORT_DATA: {
      const { reportData } = action.payload;

      return { ...state, ...reportData };
    }

    case SET_ORIGINAL_REPORT_MODEL: {
      return {
        ...state,
        originalReportModel: _.cloneDeep(action.payload.reportModel),
      };
    }

    case SET_SELECTED_CONTROL_OBJECT: {
      const { id, hasControlWrapper } = action.payload;

      return {
        ...state,
        selectedControlObject: { id, hasControlWrapper },
      };
    }

    case SET_SELECTED_TAB_INDEX: {
      return {
        ...state,
        selectedTabIndex: action.payload.index,
      };
    }

    case UPDATE_CONTROL_PROPERTIES: {
      const { id, newValues = [] } = action.payload;

      const controlProps = _.clone(state.reportModel[id]);

      newValues.forEach(({ propName, propValue }) => (controlProps[propName] = propValue));

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [id]: controlProps,
        },
      };
    }

    case UPDATE_CONTROL_PROPERTY: {
      const { id, propName, newPropValue } = action.payload;

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [id]: {
            ...state.reportModel[id],
            [propName]: newPropValue,
          },
        },
      };
    }

    case UPDATE_CONTROL: {
      const { id, controlProps } = action.payload;

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [id]: controlProps,
        },
      };
    }

    case DELETE_CONTROLS: {
      const { ids = [] } = action.payload;

      return {
        ...state,
        reportModel: _.omit({ ...state.reportModel }, ids),
      };
    }

    case ADD_NEW_DISTRIBUTION_LIST_ROW: {
      const { newRow } = action.payload;

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [REPORT_CONTROL_TYPE.DISTRIBUTION]: {
            ...state.reportModel[REPORT_CONTROL_TYPE.DISTRIBUTION],
            distributionList: [
              newRow,
              ...state.reportModel[REPORT_CONTROL_TYPE.DISTRIBUTION].distributionList,
            ],
          },
        },
      };
    }

    case ADD_NEW_DISTRIBUTION_LIST_ROWS: {
      const { rows } = action.payload;

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [REPORT_CONTROL_TYPE.DISTRIBUTION]: {
            ...state.reportModel[REPORT_CONTROL_TYPE.DISTRIBUTION],
            distributionList: [
              ...rows,
              ...state.reportModel[REPORT_CONTROL_TYPE.DISTRIBUTION].distributionList,
            ],
          },
        },
      };
    }

    case DELETE_DISTRIBUTION_LIST_ROW: {
      const { rowId } = action.payload;

      const updatedRows = state.reportModel[
        REPORT_CONTROL_TYPE.DISTRIBUTION
      ].distributionList.filter((row) => row.rowId !== rowId);

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          [REPORT_CONTROL_TYPE.DISTRIBUTION]: {
            ...state.reportModel[REPORT_CONTROL_TYPE.DISTRIBUTION],
            distributionList: updatedRows,
          },
        },
      };
    }

    case ADD_VALIDATION_ERRORS: {
      const { validationErrors } = action.payload;

      return {
        ...state,
        validationErrors,
      };
    }

    case SET_IS_REPORT_SUBMITTED: {
      const { flag } = action.payload;

      return {
        ...state,
        isReportSubmitted: flag,
      };
    }

    case DELETE_VALIDATION_ERRORS: {
      return {
        ...state,
        validationErrors: [],
      };
    }

    case CLEAR_REPORT_DESIGNER_STORE: {
      return initialState;
    }

    default:
      return state;
  }
};
